import { useEffect, useState } from "react";
import { useAppSelector } from "../../state/store";
import { populateChannelIdsDropdownForFlow } from "../../services/helpers/domainScoping";
import {
  BodySecondary,
  COLORS,
  Dropdown,
  DropdownPopover,
} from "@bikdotai/bik-component-library";
import { DropdownOption } from "@bikdotai/bik-component-library/dist/esm/components/dropdown/type";
import InstagramIcon from "../../icons/instagramIcon";
import ArrowDown from "../../icons/arrowDown";
type Option = {
  label: string;
  value: string;
  selected: boolean;
};

const InstaIdsDropdown = (props: {
  storeId: string;
  instaId?: string;
  setSelectedInsta: React.Dispatch<
    React.SetStateAction<
      | {
          label: string;
          value: string;
          selected: boolean;
        }
      | undefined
    >
  >;
}) => {
  const [instaIds, setInstaIds] = useState<Option[]>([]);
  const [loaded, setLoaded] = useState<boolean>(false);

  const flowId = useAppSelector((state) => state.homeState.flowId);
  const flowMeta: { [key: string]: any } = useAppSelector(
    (state) => state.flowMetaState.flowMeta
  );
  const domainChannelMap = useAppSelector(
    (state) => state.flowMetaState.domainChannelMap
  );
  const channels: { [key: string]: any } = useAppSelector(
    (state) => state.flowMetaState.channels!
  );

  const domain = flowMeta[flowId]?.domain;

  const instaCount = channels?.instagram?.length ?? 0;

  const mapKey = domainChannelMap ? Object.keys(domainChannelMap).join(",") : "";


  useEffect(() => {
    populateChannelIdsDropdownForFlow({
      channel: "instagram",
      channels,
      setIsLoading: (v: boolean) => setLoaded(!v),
      setSelectedChannel: (obj: any) => props.setSelectedInsta(obj),
      setChannelIdOptions: (options: Option[]) => {
        if (!options.length) {
          setInstaIds(options);
          props.setSelectedInsta({ label: "ERROR", value: "ERROR", selected: true });
          return;
        }
        if (!options.some((o) => o.selected)) {
          options = options.map((o, i) => ({ ...o, selected: i === 0 }));
          props.setSelectedInsta(options[0]);
        }
        setInstaIds(options);
      },
      currentChannelId: props.instaId?.trim(),
      domain,
      domainChannelMap,
      flowMetaEntry: flowMeta[flowId],
    });

  }, [domain, instaCount, mapKey, props.instaId, flowId]);

  const getLabel = () => {
    const selected = instaIds.find((item) => item.selected);
    return selected ? selected.label : "Select an account";
  };

  return loaded ? (
    <div
      style={{
        pointerEvents: "auto",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <DropdownPopover
        options={instaIds}
        width="fit-content"
        placement="bottom"
        strategy="fixed"
        onSelect={(option: DropdownOption | DropdownOption[]) => {
          let instaIdsCopy = [...instaIds];

          instaIdsCopy = instaIdsCopy.map((item) => {
            if (
              item.value === (option as unknown as Option).value &&
              (option as unknown as Option).selected
            ) {
              return {
                ...item,
                selected: true,
              };
            } else {
              return {
                ...item,
                selected: false,
              };
            }
          });

          if (!instaIdsCopy.filter((item) => item.selected).length) {
            instaIdsCopy[0].selected = true;
          }

          props.setSelectedInsta(
            instaIdsCopy.filter((item) => item.selected)[0]
          );

          setInstaIds(instaIdsCopy);
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 8,
            borderRadius: 4,
            border: `1px solid ${COLORS.stroke.primary}`,
            padding: "4px 4px 4px 4px",
          }}
        >
          <InstagramIcon />
          <BodySecondary>{getLabel()}</BodySecondary>
          <ArrowDown />
        </div>
      </DropdownPopover>
    </div>
  ) : (
    <></>
  );
};

export default InstaIdsDropdown;
